import Button from 'components/Button/Button';
import React from 'react';

import GOOGLE from '../../img/sso/logo-google.svg'
import LINKEDIN from '../../img/sso/logo-linkedin.svg'
import FACEBOOK from '../../img/sso/logo-facebook.svg'
import GOV_BR from '../../img/sso/logo-gov_br.svg'
import CUSTOM_OAUTH2 from '../../img/sso/logo-custom_oauth2.svg'
import { useTranslation } from 'react-i18next';

const logoMap = {
  GOOGLE,
  LINKEDIN,
  FACEBOOK,
  GOV_BR,
  CUSTOM_OAUTH2
};

const SignInSSO = (
  {
    isDisabled = true,
    ssoProvider = { provider: '', providerLabel: '', logonUrl: '', requestParam: '', type: 'OPENID', method: 'POST' },
    loading = false
  }) => {

  const { t } = useTranslation()

  const svg = logoMap[ssoProvider.provider] ?? logoMap.CUSTOM_OAUTH2

  const customWidth = ssoProvider.provider === 'GOV_BR' ? 64 : 32

  const handleOnClick = () => {
    handleOpenIdSubmit(ssoProvider.logonUrl, ssoProvider.requestParam, ssoProvider.method);
  }

  const getParamsSsoOpenIdObj = (encodeRequestParam) => {
    try {
      const plaintext = atob(encodeRequestParam)
      return JSON.parse(plaintext)
    } catch (error) {
      console.error('Error decrypt', error)
      return null
    }
  }

const handleOpenIdSubmit =  (logonUrl, requestParam, method = 'POST')=>{
     formOpenIdSubmit(logonUrl, requestParam, method);
}


const formOpenIdSubmit = (logonUrl, requestParam, method = 'POST') => {
  try {
    const {
      client_id,
      nonce,
      response_type,
      redirect_uri,
      scope
    } = getParamsSsoOpenIdObj(requestParam);

    const form = document.createElement("form");
    form.setAttribute("name", "formOpenId");
    form.setAttribute("method", method.toLowerCase());
    form.setAttribute("action", logonUrl);
    form.style.display = "none";

    const params = {
      client_id,
      nonce,
      response_type,
      redirect_uri,
      scope
    };

    Object.entries(params).forEach(([name, value]) => {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", name);
      input.setAttribute("value", value ?? "");
      form.appendChild(input);
    });

    document.body.appendChild(form);

    form.submit();

    document.body.removeChild(form);
  } catch (error) {
    console.error("formOpenIdSubmit");
    console.error(error);
    alert(t('signup.validation.error.sso.person.unauthorized'));
  }
};

  return (
    <Button
      disabled={isDisabled}
      type="confirm"
      classie="full"
      onClick={handleOnClick}
      style={{ marginBottom: 16, background: '#fdfdfd', color: 'black' }}
      loading={loading}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
          <img src={svg} alt={`Logo ${ssoProvider.providerLabel}`} style={{ height: 32, width: customWidth }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '8px' }}>
          <p style={{ marginLeft: 8 }}>{ t('signin.button.label.send.with') + ssoProvider.providerLabel}</p>
        </div>
      </div>
    </Button>
  );
};

export default SignInSSO;